import React, {FC, useState} from "react"
import {useModelContext} from '@app/contexts/model';
import {useStorageContext} from '@app/contexts/storage';
import {Button} from '@mui/material';
import {Typography} from '@mui/material';
import {InputForm} from './views/TextField';
import './FormLogin.scss'
import {ModalError} from "@app/components/FormLogin/views/ModalError/ModalError";
import {Stack} from "@mui/system";


export const FormLogin: FC = () => {

    const {authorizationModel} = useModelContext();
    const {globalStorage} = useStorageContext();
    const [login, changeLogin] = useState('');
    const [pass, changePass] = useState('');

    let disabled = !login || !pass;
    return (
        <div>
            <form autoComplete="off" className={"formLogin"}
                  onSubmit={(e) => {
                      authorizationModel.login(login, pass).then(value => {
                          globalStorage.openErrorUnAuthenticated = false
                          globalStorage.LogOutIconClicked = false
                          globalStorage.openModule = value && value.modules[0];
                      }, reason => globalStorage.handleOpenModalError());
                      e.preventDefault()
                  }}>
                <Stack spacing={2}>
                    <Typography align={'center'} variant={'h5'}>Log In</Typography>
                    <InputForm value={login} label="Login" margin="normal" onChange={v => changeLogin(v.target.value)}/>
                    <InputForm value={pass} label="Password" type="password"
                               onChange={v => changePass(v.target.value)}/>
                    <Button
                        disabled={disabled}
                        type="submit"
                        data-testid={"button-submit"}
                        variant={'contained'}
                        color={"primary"}
                    >Submit</Button>
                </Stack>
            </form>
            <ModalError/>
        </div>
    )
}
